(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/containers/play-container.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/containers/play-container.js');
"use strict";

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  withRouter
} = svs.app.ReactRouter;

const TicketWheel = svs.tickets.play.components.TicketWheel;
const TicketSunfeather = svs.tickets.play.components.TicketSunfeather;
const TicketWidget = svs.tickets.play.components.TicketWidget;
const TicketSkinSunfeather = svs.tickets.play.components.TicketSkinSunfeather;
const TicketSkinWheel = svs.tickets.play.components.TicketSkinWheel;
const PayFooter = svs.tickets.play.components.PlayFooter;
const {
  sunfeather,
  wheel
} = svs.tickets.play.utils.animations;
const PreloadSkinImages = svs.tickets.play.components.PreloadSkinImages;

const TICKET_COUNT = 31;
class PlayContainer extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onHandleGift", () => {
      const {
        ticketInfo
      } = this.props;
      const skinVariations = ticketInfo.variations;
      if (skinVariations) {
        const {
          chosenNumber
        } = this.state;
        const variation = svs.tickets.play.utils.utils.getSelectedTicketVariation(chosenNumber, ticketInfo);
        window.location.href = "../ge-bort?lott=".concat(ticketInfo.type, ":").concat(variation);
      } else {
        window.location.href = "../ge-bort?lott=".concat(ticketInfo.type);
      }
    });
    _defineProperty(this, "handleSkinsLoaded", () => {
      const {
        appTimeline
      } = this.props;
      setTimeout(() => {
        if (!appTimeline.isActive() && appTimeline.currentLabel() === 'gameReady') {
          appTimeline.resume();
        }
      }, 200);
    });
    this.state = {
      gamePayed: false,
      id: undefined,
      chosenNumber: parseInt(svs.tickets.play.utils.utils.getTicketStash(), 10) || 1
    };
    this.onGamePay = this.onGamePay.bind(this);
    this.animationDone = this.animationDone.bind(this);
    this.onGameDemo = this.onGameDemo.bind(this);
    this.handleNumberChanged = this.handleNumberChanged.bind(this);
    const {
      appTimeline: _appTimeline
    } = this.props;
    const doNotResetProgress = !(!_appTimeline.isActive() && _appTimeline.currentLabel() === 'gameReady');
    if (doNotResetProgress) {
      _appTimeline.progress(0, false);
    }
    window.scrollTo(0, 0);
  }
  componentDidMount() {
    const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    const preChosenTicket = svs.utils.paramHandler.get({
      key: 'betala'
    }).value;
    if (preChosenTicket && isLoggedIn) {
      this.onGamePay({
        preChosenTicket
      });
    } else if (preChosenTicket && !isLoggedIn) {
      svs.utils.paramHandler.remove({
        key: 'betala'
      });
    }
  }
  componentWillReceiveProps(newProps) {
    const {
      ticketInfo
    } = newProps;
    if (this.props.ticketInfo.type !== ticketInfo.type) {
      this.props.appTimeline.restart();
      this.setState({
        gamePayed: false
      });
    }
  }
  onGamePay() {
    let {
      preChosenTicket
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      appTimeline,
      history,
      ticketInfo
    } = this.props;
    const {
      OUTRO_DURATION
    } = svs.core.detect.breakpoint.greaterThan('sm') ? sunfeather : wheel; 
    const selectedNb = preChosenTicket || svs.tickets.play.utils.utils.getTicketStash() || 1;
    const variation = svs.tickets.play.utils.utils.getSelectedTicketVariation(selectedNb, ticketInfo);
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.set({
        key: 'betala',
        value: selectedNb
      });
    } else {
      svs.utils.paramHandler.remove({
        key: 'betala'
      });
    }
    this.setState({
      gamePayed: true,
      id: 'PENDING'
    });
    window.dispatchEvent(new CustomEvent('PRELOAD_TICKET', {
      detail: {
        history,
        isPending: ticketInfo.isLeia,
        skinId: variation,
        ticketInfo,
        ticketNumber: selectedNb
      }
    }));
    appTimeline.progress(1);
    setTimeout(this.animationDone, OUTRO_DURATION.reduce((a, b) => a + b) * 1000);
  }
  onGameDemo() {
    const {
      appTimeline,
      history,
      ticketInfo
    } = this.props;
    const {
      OUTRO_DURATION
    } = svs.core.detect.breakpoint.greaterThan('sm') ? sunfeather : wheel; 
    this.setState({
      gamePayed: true
    });
    const selectedNb = svs.tickets.play.utils.utils.getTicketStash() || 1;
    const variation = svs.tickets.play.utils.utils.getSelectedTicketVariation(selectedNb, ticketInfo);
    window.dispatchEvent(new CustomEvent('PRELOAD_TICKET', {
      detail: {
        history,
        isPending: ticketInfo.isLeia,
        skinId: variation,
        ticketInfo,
        ticketNumber: selectedNb,
        demo: true
      }
    }));
    appTimeline.progress(1);
    setTimeout(this.animationDone, OUTRO_DURATION.reduce((a, b) => a + b) * 1000);
  }
  handleNumberChanged(number) {
    if (!this.state.gamePayed) {
      this.setState({
        chosenNumber: number
      });
      svs.tickets.play.utils.utils.stashTicket(number);
    }
  }
  animationDone() {
    const {
      id
    } = this.state;
    const {
      history,
      ticketInfo
    } = this.props;
    const selectedNb = svs.tickets.play.utils.utils.getTicketStash() || 1;
    svs.tickets.logger.info('Ticket picked, ticket nr:', selectedNb);
    const variation = svs.tickets.play.utils.utils.getSelectedTicketVariation(selectedNb, ticketInfo);
    if (id) {
      history.push("../spela/".concat(ticketInfo.alternativeUrl || ticketInfo.type, "/").concat(id, "?skinId=").concat(variation, "&ticketNumber=").concat(selectedNb));
    } else {
      history.push("../spela/".concat(ticketInfo.alternativeUrl || ticketInfo.type, "/demo?skinId=").concat(variation, "&ticketNumber=").concat(selectedNb));
    }
  }
  render() {
    const {
      gamePayed,
      chosenNumber
    } = this.state;
    const {
      appTimeline,
      ticketInfo
    } = this.props;
    const {
      type,
      alternativeUrl,
      skins,
      variations,
      animation
    } = ticketInfo;
    const Picker = svs.core.detect.breakpoint.greaterThan('sm') ? TicketSunfeather : TicketWheel;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "".concat(alternativeUrl || type, " ").concat(gamePayed && 'state-game-payed')
    }, React.createElement(TicketWidget, null), React.createElement(PreloadSkinImages, {
      onLoaded: this.handleSkinsLoaded,
      ticketInfo: ticketInfo
    }), React.createElement(Picker, {
      accessibleText: "V\xE4lj lott. G\xE5 vidare f\xF6r att betala, ge bort eller provspela. Denna produkt \xE4r ".concat(ticketInfo.accessible ? '' : 'inte', " tillg\xE4nglighetsanpassad."),
      appTimeline: appTimeline,
      gamePayed: gamePayed,
      handleGamePay: this.onGamePay,
      key: ticketInfo.type,
      onHandleNumberChanged: this.handleNumberChanged
    }, [...new Array(TICKET_COUNT)].map((empty, index) => {
      var _skins, _skins2;
      return svs.core.detect.breakpoint.greaterThan('sm') ? React.createElement(TicketSkinSunfeather, {
        animation: animation,
        appTimeline: appTimeline,
        chosen: index + 1 === chosenNumber,
        gamePayed: gamePayed,
        handleGamePay: this.onGamePay,
        image: (_skins = skins[index % variations]) === null || _skins === void 0 ? void 0 : _skins.image,
        key: "ticket-skin-index-".concat(index),
        number: index + 1,
        numberOfTickets: TICKET_COUNT,
        onHandleNumberChanged: this.handleNumberChanged
      }) : React.createElement(TicketSkinWheel, {
        animation: animation,
        appTimeline: appTimeline,
        chosen: index + 1 === chosenNumber,
        gamePayed: gamePayed,
        handleGamePay: this.onGamePay,
        image: (_skins2 = skins[index % variations]) === null || _skins2 === void 0 ? void 0 : _skins2.image,
        key: "ticket-skin-index-".concat(index),
        number: index + 1,
        onHandleNumberChanged: this.handleNumberChanged
      });
    }))), React.createElement(PayFooter, {
      appTimeline: appTimeline,
      gamePayed: gamePayed,
      handleGameDemo: this.onGameDemo,
      handleGamePay: this.onGamePay,
      handleGift: this.onHandleGift,
      ticketInfo: ticketInfo
    }));
  }
}
setGlobal('svs.tickets.play.containers.PlayContainer', withRouter(PlayContainer));

 })(window);